#import "~/graphql/fragments/CraftLink.graphql"
#import "~/graphql/fragments/Assets/DefaultImageAsset.graphql"

fragment ContentBlockCallToAction on contentBlocks_callToAction_BlockType {
    title: sectionTitle
    description

    cta {
        ... CraftLink
    }

    image {
        ... DefaultImageAsset
    }

    markermask

    anchorId
    anchorLabel
}
